import { Injectable } from '@angular/core';

import { Combustivel } from "./combustivel.model";
import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";

@Injectable()
export class CombustivelApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Combustivel, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Combustivel, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"combustivel"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        this._restService.onGetPostId(apiName, objectId, {}, done);
    }

    onGetApiUrl() {
        return apiName;
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/combustiveis/shared/combustivel-api.service.ts
 **/